/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/account-settings';

const TrackedButton = withSingleTracked({ type: 'BUTTON' })<ButtonProps>(Button);

const styles = {
  // Styles are unsetting this.
  button: css`
    box-shadow: inset 0 0 0 1px var(--cds-color-interactive-primary);
  `,
};

export default class DisableTwoFactorAuthentication extends React.Component {
  disableTwoFactorAuthentication = () => {
    SettingsActionCreators.disableTwoFactorAuthentication();
  };

  render() {
    return (
      <div>
        <p>{_t('Two-Factor Authentication is enabled for your account')}</p>
        <TrackedButton
          variant="primaryInvert"
          css={styles.button}
          onClick={this.disableTwoFactorAuthentication}
          trackingName="disable_two_factor_auth"
        >
          {_t('Disable Two-Factor Authentication')}
        </TrackedButton>
      </div>
    );
  }
}
